import React from "react";
import Modal from "./Modal";
const BootstrapModalWrapper = ({ showModal, children, onHide, bsSize = void 0, backdrop = void 0 }) => /* @__PURE__ */ React.createElement(Modal, { show: showModal, onHide, bsSize, backdrop }, children);
export default BootstrapModalWrapper;
